import { filterOptions } from '@/utils/query-base'
import { formatSapDate, formatSapTime, formatSapDateTime } from '@/mixins/index'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
const status = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY'])

/**
 * describe：展示字段是否是描述
 * title：表头字段名称
 *
 * equation：条件
 *
 * type 如果有值将会作为查询条件
 *  -input： 输入框
 *  -select：
 *    dictionary：为字典编码 特殊字典(营销单元(sale)， 基地(base)，省(region)，市(city)，区(street))
 *  -dialog：
 *    dialog：{
 *      component 弹窗组件 ClientSelect ProductSelect
 *      title 弹窗title
 *    }
 *  -date 时间 格式 年-月-日
 *  -time 时间 格式 时:分:秒
 *  -year 年   格式 年
 *  -whether  是否选项
 */
export const pageSearch = {
  'inv_status': {
    describe: true,
    type: 'select',
    title: '单据状态',
    equation: status,
    dictionary: 'A0033'
  },
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale',
    defaultOption: "NE", //默认选择条件
    defaultVal: ['0005000310','0005000172']
  },
  'order_cust_name': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'description': {
    title: '产品名称',
    type: 'input',
    equation: cusname,
    width: 400
  },
  'chfl': {
    describe: true,
    type: 'select',
    title: '存货分类',
    equation: all,
    dictionary: 'A0019'
  },
}

export default {
  'zzfld000001_text': {
    title: '营销单元', // 字段名称
  },
  'mak_date': {
    title: '开票日期',
    type: 'date',
    equation: all,
    defaultVal: '2024-11-26',
    width: 100,
    defaultOption: "GE",
    valueFormat: 'yyyy-MM-dd'
  },
  'w_invo_infoid': {
    title: '外部制票通知单号',
    type: 'input',
    equation: all,
    width: 140
  },
  'invo_infoid': {
    title: '制票通知单号',
    type: 'input',
    equation: all
  },
  'invo_item': {
    title: '行号',
    width: 70,
    formatter: ({ cellValue }) => cellValue && Number(cellValue),
    xlsxFmt: {
      t: 'n'
    }
  },
  'object_id': {
    title: '销售订单',
    type: 'input',
    equation: all
  },
  'ems_number': {
    title: 'EMS单号',
    type: 'input',
    equation: all,
    width: 100
  },
  'new_order_cust_name': {
    title: '最新订单客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'new_cust_name': {
    title: '最新开票客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'cust_name': {
    title: '开票客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'order_cust_name': {
    title: '订单客户名称',
    width: 250
  },
  'order_customer_type': {
    describe: true,
    title: '订单客户类型',
    type: 'select',
    equation: all,
    dictionary: 'A0009'
  },
  'zzcustchal': {
    describe: true,
    title: '客户渠道类型',
    type: 'select',
    equation: all,
    dictionary: 'A0064'
  },
  'reserved9_text': {
    title: '指挥中心分类'
  },
  'description': {
    title: '产品名称',
    width: 400
  },
  'use_zzfld9': {
    title: '件',
    xlsxFmt: {
      t: 'n'
    }
  },
  'use_quantity': {
    title: '瓶',
    xlsxFmt: {
      t: 'n'
    }
  },
  'use_dun': {
    title: '吨',
    xlsxFmt: {
      t: 'n'
    }
  },
  'net_price': {
    title: '含税单价',
    xlsxFmt: {
      t: 'n'
    }
  },
  'pure_value': {
    title: '价税合计(折扣后)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'net_value': {
    title: '价税合计(折扣前)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002i': {
    title: '折扣额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002f': {
    title: '单品折扣'
  },
  'manual_invo': {
    title: '提货票',
    type: 'input',
    equation: cusname
  },
  'invo_id': {
    title: '发票号',
    type: 'input',
    equation: cusname
  },
  'zzfld00002d_dscr': {
    title: '制单人',
    type: 'input',
    equation: cusname
  },
  'pcate': {
    describe: true,
    type: 'select',
    title: '产品分类',
    equation: all,
    dictionary: 'A0028'
  },
  'brand_bq': {
    describe: true,
    type: 'select',
    title: '品牌BQ',
    equation: all,
    dictionary: 'A0018'
  },
  'chfl_text': {
    title: '存货分类',
  },
  'ycate': {
    describe: true,
    type: 'select',
    equation: cusname,
    title: '月报分类',
    dictionary: 'A0016'
  },
  'bcate': {
    title: '大类名称',
    type: 'input',
    equation: all
  },
  'mcate': {
    title: '中类名称',
    type: 'input',
    equation: all
  },
  'scate': {
    title: '小类名称',
    type: 'input',
    equation: all
  },
  'cmade': {
    title: '是否定制',
    type: 'whether',
    equation: be
  },
  'isept': {
    title: '是否出口',
    type: 'whether',
    equation: be
  },
  'numbr': {
    title: '编码',
    type: 'input',
    equation: cusname
  },
  'beiyong': {
    title: '备用项',
    type: 'input',
    equation: all
  },
  'isyy': {
    title: '是否预约订单',
    type: 'whether',
    equation: be
  },
  'yy_confirm': {
    title: '预约确认号',
    type: 'whether',
    equation: be
  },
  'inf_type': {
    describe: true,
    type: 'select',
    title: '制票通知单类型',
    equation: cusname,
    dictionary: 'A0022'
  },
  'gjahr': {
    title: '要货年',
    type: 'year',
    equation: city,
    slot: true
  },
  'monat': {
    title: '要货月份',
    type: 'select',
    equation: city,
    dictionary: 'month'
  },
  'capty': {
    title: '容量',
    type: 'number',
    equation: cusname,
    xlsxFmt: {
      t: 'n'
    }
  },
  'degree': {
    title: '度数',
    type: 'number',
    equation: cusname
  },
  'customer': {
    title: '开票客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编号'
    }
  },
  'order_customer': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户编号'
    }
  },
  'zzfld00001h': {
    describe: true,
    type: 'select',
    title: '营销单元(订单客户)',
    equation: all,
    dictionary: 'sale'
  },
  'zzfld00003e': {
    describe: true,
    type: 'select',
    title: '基地(订单客户)',
    equation: all,
    dictionary: 'base'
  },
  'ordered_prod': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    }
  },
  'inv_type': {
    describe: true,
    type: 'select',
    title: '发票类型',
    dictionary: 'A0032'
  },
  'zzfld000004_dscr': {
    title: '业务员',
    type: 'input',
    equation: cusname
  },
  'recinv_pers': {
    title: '收票联系人',
    type: 'input',
    equation: cusname
  },
  'recinv_tel': {
    title: '收票联系人电话',
    type: 'input',
    equation: cusname
  },
  'inv_addr': {
    title: '收票地址',
    type: 'input',
    equation: cusname
  },
  'remark': {
    title: '发票表头备注',
    type: 'input',
    equation: cusname
  },
  'item_remark': {
    title: '发票行备注',
    type: 'input',
    equation: cusname
  },
  'order_remark': {
    title: '订单表头备注',
    type: 'input',
    equation: cusname
  },
  'zzfld000002': {
    describe: true,
    suffix:'_text',
    title: '省',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'zzfld000003': {
    describe: true,
    suffix:'_text',
    title: '市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'streetcode': {
    describe: true,
    suffix:'_text',
    type: 'select',
    title: '区县',
    equation: city,
    dictionary: 'street'
  },
  'method': {
    title: '运行方式',
    type: 'select',
    equation: all,
    dictionary: 'method'
  },
  'chan_date': {
    title: '换票日期',
    type: 'date',
    equation: all
  },
  'send_qty': {
    title: '已发运数量',
    type: 'input',
    equation: cusname,
    xlsxFmt: {
      t: 'n'
    }
  },
  'inv_status': {
    describe: true,
    type: 'select',
    title: '单据状态',
    equation: status,
    dictionary: 'A0033'
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: cusname,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'datumtime': {
    title: '创建时间',
    width: 160,
    equation: cusname,
    formatter: ({ cellValue }) => formatSapTime(cellValue)
  },
  'plan_type': {
    describe: true,
    type: 'select',
    title: '计划类型',
    equation: cusname,
    dictionary: 'A0002'
  },
  'guaranty': {
    title: '随货保证金',
    type: 'number',
    equation: cusname,
    xlsxFmt: {
      t: 'n'
    }
  },
  'connect_invo_infoid': {
    title: '对应制票通知单号',
    type: 'input',
    equation: all
  },
  'qyxtg': {
    title: '是否公关团购',
    type: 'whether',
    equation: be
  },
  'zzfld00002j': {
    describe: true,
    type: 'select',
    title: '运达方类型',
    dictionary: 'A0009',
    equation: all
  },
  'zzfld00002k': {
    describe: true,
    type: 'select',
    title: '发货类型',
    equation: all,
    dictionary: 'A0005'
  },
  'zzfld00008t': {
    title: '运达方编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '运达方编码'
    }
  },
  'zzfld00008t_dscr': {
    title: '运达方名称',
    type: 'input',
    equation: cusname
  },
  'zzfld00002l': {
    title: '收货联系人',
    type: 'input',
    equation: cusname
  },
  'zzfld00002m': {
    title: '收货联系人电话',
    type: 'input',
    equation: cusname
  },
  'zzfld00002n': {
    title: '收货地址',
    type: 'input',
    equation: cusname
  },
  'zzfld00008x': {
    title: '终端名称',
    type: 'input',
    equation: cusname
  },
  'trans_date': {
    title: '待审核日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'trans_datetime': {
    title: '待审核时间',
    equation: all,
    width: 160,
    formatter: ({ cellValue }) => formatSapDateTime(cellValue)
  },
  // 'trans_time': {
  //   title: '待审核时间',
  //   type: 'time',
  //   equation: cusname,
  //   formatter: ({ cellValue }) => formatSapTime(cellValue)
  // },
  'changin_date': {
    title: '审核日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'changin_datetime': {
    title: '审核时间',
    equation: all,
    width: 160,
    formatter: ({ cellValue }) => formatSapDateTime(cellValue)
  },
  // 'changin_time': {
  //   title: '审核时间',
  //   type: 'time',
  //   equation: cusname,
  //   formatter: ({ cellValue }) => formatSapTime(cellValue)
  // },
  'posting_date': {
    title: '订单创建日期',
    type: 'date',
    equation: cusname,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'posting_datetime': {
    title: '订单创建时间',
    type: 'date',
    width: 160,
    equation: cusname,
    formatter: ({ cellValue }) => formatSapDateTime(cellValue)
  },
  'zcustom_name': {
    title: '定制名称',
    type: 'input',
    width: 200
  },
  'zzfld000001_new': {
    describe: true, // 描述 _text 添加属性
    title: '最新营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale'
  },
  'zzfld00002a': {
    describe: true,
    suffix:'_text',
    title: '折扣类型',
    type: 'select',
    dictionary: 'A0037'
  },
  'reward_name': {
    title: '项目类型名称', // 字段名称
    type: 'input',
  },
  'red_type': {
    describe: true,
    title: '红冲', // 字段名称
    type: 'select',
    equation: cusname,
    dictionary: 'A0082'
  },
  'old_invo_id': {
    title: '原发票号', // 字段名称
    type: 'input',
  },
  'xmzke': {
    title: '项目折扣额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'new_order_cust_type': {
    describe: true,
    title: '最新订单客户类型',
    type: 'select',
    equation: all,
    dictionary: 'A0009'
  },
  // 'datum': {
  //   title: '创建日期',
  //   type: 'date',
  //   equation: all,
  //   formatter: ({ cellValue }) => formatSapDate(cellValue)
  // },
  // 'uzeit': {
  //   title: '创建时间',
  //   type: 'time',
  //   equation: cusname,
  //   formatter: ({ cellValue }) => formatSapTime(cellValue)
  // }
  // 'customer2': {
  //   title: '老商家编码',
  //   type: 'dialog', // 弹窗
  //   equation: city,
  //   dialog: {
  //     component: 'ClientSelect', // 弹窗组件名称 (客户 ClientSelect)(产品 ProductSelect)
  //     title: '老商家选择' // 弹窗标题
  //   }
  // },
  // 'cust_name2': {
  //   title: '老商家名称',
  //   equation: city,
  //   type: 'input'
  // },

  // 'customer1': {
  //   title: '新商家编码',
  //   type: 'dialog',
  //   equation: city,
  //   dialog: {
  //     component: 'ClientSelect',
  //     title: '新商家编码'
  //   }
  // },
  // 'cust_name1': {
  //   title: '新商家名称',
  //   equation: city,
  //   type: 'input'
  // },
  // 'division': {
  //   title: '部门',
  //   type: 'input',
  //   equation: cusname
  // }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/dealersMakeInvoiceReportForms.js